import { hasDefinedValue } from '@sgme/fp';
import type { PersistedTabContent, ProductModificationPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { productModificationFormRequested } from 'state/productModificationForm/productModificationForm.action';
import type { EpicWithThunk } from 'state/state.common';

export function fillProductModificationTabContentInPostTradeScreenEpic(): EpicWithThunk {
  return (action$, _state$, { frontLogger }) => {
    return action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace }) => workspace === 'postTrade'),
      filter(({ tabType }) => tabType === 'productModification'),
      filter(hasDefinedValue('tabContent')),
      map(({ tabId, tabContent }) => productModificationFormRequestedFromTabContent(tabId, tabContent)),
      catchError(err => {
        frontLogger.error('Error in fillProductModificationTabContentInPostTradeScreenEpic {@FrontError}', err);
        return EMPTY;
      }),
    );
  };
}

const productModificationFormRequestedFromTabContent = (tabId: string, tabContent: PersistedTabContent) => {
  const productModidicationTabContent = asProductModificationTabContent(tabContent);
  return productModificationFormRequested(tabId, productModidicationTabContent.productId);
};

const asProductModificationTabContent = (tabContent: PersistedTabContent) =>
  tabContent as ProductModificationPersistedTabContent;
